// extracted by mini-css-extract-plugin
module.exports = {"lockScroll":"Overlay_lockScroll__C4jCv","overlay":"Overlay_overlay__U9uEb","active":"Overlay_active__u57o4"};